import { ProviderHubFiltersRequestModel, ReadyForReviewModel, SpecialtyProviderCountModel } from "@app/projects/network-assessment/provider-hub/interfaces";
import ProviderHubService from "@app/projects/network-assessment/provider-hub/providerHubService";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

export interface ReadyForReviewResult {
  isError: boolean;
  isLoading: boolean;
  networkExpansionOpportunitiesData: SpecialtyProviderCountModel[] | undefined;
  networkExpansionOpportunitiesHasData: boolean;
  networkExpansionOpportunitiesTotalCount: number | undefined;
  underperformingProvidersData: SpecialtyProviderCountModel[] | undefined;
  underperformingProvidersHasData: boolean;
  underperformingProvidersTotalCount: number | undefined;
}

export const READY_FOR_REVIEW_QUERY_KEY_PREFIX = "pci-dashboard__ready-for-review";

export const useReadyForReview = (providerFiltersRequestModel: ProviderHubFiltersRequestModel | null): ReadyForReviewResult => {
  const providerHubService = useRef(new ProviderHubService()).current;

  const queryResult = useQuery<ReadyForReviewModel>({
    enabled: providerFiltersRequestModel !== null,
    queryFn: async ({ signal }) => providerHubService.getPciDashboardReadyForReviewData(providerFiltersRequestModel, signal),
    queryKey: [READY_FOR_REVIEW_QUERY_KEY_PREFIX, JSON.stringify(providerFiltersRequestModel)],
    staleTime: 5 * 60 * 1000,
  });

  return {
    isError: queryResult.isError,
    isLoading: queryResult.isFetching,
    networkExpansionOpportunitiesData: queryResult.data?.networkExpansionOpportunities,
    networkExpansionOpportunitiesHasData: queryResult.isSuccess && queryResult.data.networkExpansionOpportunities.some(x => x.providerCount > 0),
    networkExpansionOpportunitiesTotalCount: queryResult.data?.networkExpansionOpportunitiesTotalCount,
    underperformingProvidersData: queryResult.data?.underperformingProviders,
    underperformingProvidersHasData: queryResult.isSuccess && queryResult.data.underperformingProviders.some(x => x.providerCount > 0),
    underperformingProvidersTotalCount: queryResult.data?.underperformingProvidersTotalCount,
  };
}